import { useEffect, useState, useContext } from "react";
import LanguageContext from "../context/language-context";
const useFetch = (url) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const languageCtx = useContext(LanguageContext);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const res = await fetch(url);
        const json = await res.json();

        setData(json);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    fetchData();
  }, [url, languageCtx.languageData]);

  return { loading, error, data };
};

export default useFetch;
